/**
 * BRIXO - Cart JavaScript
 * Cart functionality and AJAX operations
 */

document.addEventListener('DOMContentLoaded', function() {
  initCartActions();
  initAddToCart();
});

/**
 * Initialize Cart Item Actions
 */
function initCartActions() {
  document.addEventListener('click', async (e) => {
    const target = e.target.closest('[data-action]');
    if (!target) return;
    
    const action = target.dataset.action;
    const key = target.dataset.key;
    
    if (!key) return;
    
    e.preventDefault();
    
    switch (action) {
      case 'increase':
        await updateCartItem(key, 'increase');
        break;
      case 'decrease':
        await updateCartItem(key, 'decrease');
        break;
      case 'remove':
        await removeCartItem(key);
        break;
    }
  });
}

/**
 * Initialize Add to Cart Forms
 */
function initAddToCart() {
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;
    
    e.preventDefault();
    
    const submitBtn = form.querySelector('[type="submit"]');
    const originalText = submitBtn.innerHTML;
    
    // Loading state
    submitBtn.disabled = true;
    submitBtn.innerHTML = `
      <svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10" stroke-opacity="0.25"></circle>
        <path d="M12 2a10 10 0 0 1 10 10" stroke-opacity="1"></path>
      </svg>
      Toevoegen...
    `;
    
    try {
      const formData = new FormData(form);
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });
      
      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }
      
      const item = await response.json();
      
      // Success state
      submitBtn.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
        Toegevoegd!
      `;
      
      // Update cart count
      const cart = await window.Brixo.fetchCart();
      if (cart) {
        window.Brixo.updateCartCount(cart.item_count);
      }
      
      // Refresh cart drawer content
      await refreshCartDrawer();
      
      // Open cart drawer
      window.Brixo.openCartDrawer();
      
      // Reset button after delay
      setTimeout(() => {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
      }, 2000);
      
    } catch (error) {
      console.error('Add to cart error:', error);
      
      submitBtn.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="15" y1="9" x2="9" y2="15"></line>
          <line x1="9" y1="9" x2="15" y2="15"></line>
        </svg>
        Fout!
      `;
      
      setTimeout(() => {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
      }, 2000);
    }
  });
}

/**
 * Update Cart Item Quantity
 */
async function updateCartItem(key, action) {
  try {
    // Get current cart
    const cart = await window.Brixo.fetchCart();
    const item = cart.items.find(i => i.key === key);
    
    if (!item) return;
    
    let newQuantity = item.quantity;
    
    if (action === 'increase') {
      newQuantity += 1;
    } else if (action === 'decrease') {
      newQuantity = Math.max(0, newQuantity - 1);
    }
    
    if (newQuantity === 0) {
      await removeCartItem(key);
      return;
    }
    
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: newQuantity
      })
    });
    
    if (!response.ok) {
      throw new Error('Failed to update cart');
    }
    
    const updatedCart = await response.json();
    
    // Update UI
    window.Brixo.updateCartCount(updatedCart.item_count);
    await refreshCartDrawer();
    
  } catch (error) {
    console.error('Update cart error:', error);
  }
}

/**
 * Remove Cart Item
 */
async function removeCartItem(key) {
  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: 0
      })
    });
    
    if (!response.ok) {
      throw new Error('Failed to remove item');
    }
    
    const updatedCart = await response.json();
    
    // Update UI
    window.Brixo.updateCartCount(updatedCart.item_count);
    await refreshCartDrawer();
    
    // Close drawer if cart is empty
    if (updatedCart.item_count === 0) {
      setTimeout(() => {
        window.Brixo.closeCartDrawer();
      }, 500);
    }
    
  } catch (error) {
    console.error('Remove item error:', error);
  }
}

/**
 * Refresh Cart Drawer Content
 */
async function refreshCartDrawer() {
  try {
    const response = await fetch('/?section_id=cart-drawer');
    const html = await response.text();
    
    // Parse the HTML and extract the cart drawer content
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const newContent = doc.querySelector('[data-cart-drawer]');
    
    if (newContent) {
      const currentDrawer = document.querySelector('[data-cart-drawer]');
      const wasOpen = currentDrawer && !currentDrawer.hidden;
      
      currentDrawer.innerHTML = newContent.innerHTML;
      
      if (wasOpen) {
        currentDrawer.hidden = false;
      }
    }
  } catch (error) {
    console.error('Refresh cart drawer error:', error);
    // Fallback: reload the page
    // window.location.reload();
  }
}

// CSS for spinner animation
const style = document.createElement('style');
style.textContent = `
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
  .animate-spin {
    animation: spin 1s linear infinite;
  }
`;
document.head.appendChild(style);







